import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import CrmIntegradoRdStation from "@/pages/CrmIntegradoRdStation";

export const Route = createFileRoute("/crm-integrado-rd-station")({
  head: () => buildHead({
    title: "CRM integrado com RD Station e WhatsApp | OP2P",
    description: "Integre o RD Station à OP2P CRM: leads das suas campanhas chegam ao funil e os Agentes de IA atendem no WhatsApp e Instagram em segundos.",
    path: "/crm-integrado-rd-station",
  }),
  component: CrmIntegradoRdStation,
});
